<template>
  <div>
    <component style="display: none" :is="show_document"></component>

    <CRow>
      <CCol md="12" class="mb-5">
        <CCard>
          <CCardHeader>
            <CRow>


              <CCol col="4" style="text-align: start">
                <strong>{{ $t('components.driverDocumentList') }} {{ driver_name }}</strong>

              </CCol>
              <CCol col="8" class="text-end">

                <CButton
                    color="primary"
                    variant="outline"
                    square
                    class="mx-1"
                    v-if="id_checkbox_items.length>0"
                    size="sm"
                    @click="add_signature(0)"
                >{{ $t('Confirm') }}
                </CButton>
                <CButton
                    color="primary"
                    variant="outline"
                    square
                    v-if="refer_person !=null"
                    size="sm"
                    @click="get_lists_pdf()"
                >{{ $t('buttons.print') }}
                </CButton>
              </CCol>

            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <div style="display: flex">
                <div @click="change_person(item)" v-for="item in persons"
                     style="cursor:pointer;margin:2px;width:fit-content;background: #0d6efd;color: white;padding: 4px 5px;border-radius: 10px">
                  {{ item.personName }} {{ item.middelName }} {{ item.surName }}
                </div>
              </div>
              <CCol col="4">
                <treeselect
                    v-model="refer_person"
                    :async="refer_person_async"

                    :options="refer_person_items"
                    :load-options="load_persons"
                    :placeholder="$t('components.searchUser')"
                    :normalizer="normalizer_persons"
                />

              </CCol>
              <CCol col="3">
                <date-picker

                    :label="$t('tables.date')"
                    v-model="refer_date"></date-picker>
              </CCol>
              <CCol col="3">
                <CButton color="dark"
                         @click="get_all_data()"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>
            </CRow>
            <CDataTable
                :items="items_buy"
                :fields="fields"
                :sorter-value="{column:'masterFactorId', asc:false}"
                :items-per-page="20"
                hover
                sorter
                column-filter
                pagination
            >
              <template #row="{item}">

                <td>
                  <p style="text-align:center">{{ item.row_id + 1 }}</p>

                </td>

              </template>
              <template #date="{item}">

                <td>
                  <p>{{ get_date(item.createdAt) }}</p>

                </td>

              </template>

              <template #warehouse="{item}">
                <td>
                  <p>{{ item.placeName }}</p>

                </td>

              </template>
              <template #select-header>
                <td>
                  <input type="checkbox" ref="permissions[]" v-model="check_all"/>
                </td>
              </template>

              <template #select="{item}">
                <td>
                  <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                         :value="item.masterFactorId"/>
                </td>
              </template>

              <template #price="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency(item.price) }} </p>
                </td>
              </template>
              <template #customer="{item}">

                <td>
                  <p>{{ item.personName }}</p>

                </td>

              </template>
              <template #summary="{item}">

                <td>
                  <p>{{ item.masterFactorTitle }}</p>

                </td>

              </template>


              <template #operation="{item,index}">
                <td>
                  <CButton
                      color="danger"
                      variant="outline"
                      square
                      size="sm"
                      @click="delete_item_dialog(item,index)"
                  >{{ $t('buttons.cancelRefer') }}
                  </CButton>
                  <CButton
                      color="primary"
                      variant="outline"
                      square
                      size="sm"
                      @click="goShowDocument(item,index)"
                  >{{ $t('buttons.show') }}
                  </CButton>
                  <CButton
                      color="success"
                      square
                      size="sm"
                      @click="goPrintDocument(item,index)"
                  >{{ $t('buttons.print') }}
                  </CButton>
                </td>
              </template>


            </CDataTable>

          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>

        <CCard id="printMe_products">
          <CCardHeader>
            <strong>{{ $t('components.temporaryDocumentsProducts') }}</strong>
            <div v-if="refer_person!=null"><p>
              {{ searched_persons.filter(x => x.userId == refer_person)[0].userName }}
              {{ searched_persons.filter(x => x.userId == refer_person)[0].surName }}

            </p></div>
            <div v-if="refer_date!=null">
              <p> {{ get_date(refer_date) }}</p>
            </div>
          </CCardHeader>
          <CCardBody>
            <CDataTable
                :items="items_products"
                :fields="fields_products"

                :items-per-page="200"
                hover
                sorter
                pagination
            >
              <template #row="{item}">

                <td>
                  <strong style="font-size: 16px;">{{ item.row_id + 1 }}</strong>

                </td>

              </template>
              <template #product="{item}">

                <td>
                  <strong style="font-size: 16px;">{{ item.productName }}</strong>

                </td>

              </template>

              <template #qty="{item}">
                <td>
                  <strong style="text-align:center;font-size: 16px;">{{ Math.abs(item.productCount / item.unitValue) }}</strong>

                </td>

              </template>
              <template #weight="{item}">

                <td>
                  <strong style="font-size: 16px;">{{ item.weight }}</strong>

                </td>


              </template>
              <template #unit="{item}">

                <td>
                  <strong style="font-size: 16px;">{{ item.productUnitName }}</strong>

                </td>

              </template>


            </CDataTable>

          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
        <CButton @click="print_products()" size="sm"
                 color="primary">
          <CIcon name="cil-check-circle"/>
          {{ $t('buttons.print') }}
        </CButton>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';

// import FilterHeader from "../includes/FilterHeader";
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',

  ]
}

Vue.use(VueHtmlToPaper, options);


var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}


export default {
  name: 'Login',
  components: {
    // FilterHeader,
    Treeselect,
    'test-dynamic': () => import('../documents/PrintDocument'),

  },
  data() {
    return {
      show_document: 'test-dynamic',
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      check_all: false,
      id_checkbox_items: [],
      name: '',
      file: '',
      driver_name: '',
      color: '#ffffff',
      previewImage: '',
      submit_refer: 0,
      refer_person: null,
      refer_person_async: true,
      refer_person_items:[],
      refer_date: null,
      selected_template: 0,
      description: null,
      persons: [],
      items_buy: [],
      items_final: [],

      items_products: [],
      fields: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:5%'},
        {key: 'masterFactorCode', label: this.$t('tables.factorId'), _style: 'width:10%'},
        {key: 'warehouse', label: this.$t('tables.warehouse'), _style: 'width:10%'},
        {key: 'price', label: this.$t('tables.price'), _style: 'width:10%'},
        {key: 'customer', label: this.$t('tables.customer'), _style: 'width:10%'},
        {key: 'date', label: this.$t('tables.referDate'), _style: 'width:5%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:10%;'},
        {key: 'select', label: this.$t('tables.operation'), _style: 'width:3%;'},

      ],

      fields_products: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:3%;padding:0px'},
        {key: 'product', label: this.$t('tables.product'), _style: 'width:20%;padding:0px'},
        {key: 'weight', label: this.$t('tables.weight'), _style: 'width:7%;padding:0px'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:5%;padding:0px'},
        {key: 'unit', label: this.$t('tables.unit'), _style: 'width:5%;padding:0px'},

      ],


      details: [],
      templates_items: [
        {template_id: 'One', name: 'A'},
        {template_id: 'Two', name: 'B'},
        {template_id: 'Three', name: 'C'}
      ],
      searched_persons: [],
      collapseDuration: 0,
      status_form: 0,
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
        }
      },
    }
  },
  mounted() {

    this.$root.root_validate_errors = [];


    this.get_persons();
    // this.get_lists_final();
    // this.get_lists_products();

    bus.$on('delete_confirm_cancel_refer' + this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });

  },
  watch: {
    'check_all': function () {

      const self = this
      if (this.check_all == false) {
        this.id_checkbox_items = []

      } else {
        this.id_checkbox_items = []
        this.items_buy.forEach(function (val) {
          self.id_checkbox_items.push(val.masterFactorId)
        })
      }
    },

    'refer_person': function () {
      if (this.refer_person != null) {
        this.get_all_data()
      }

    },
    'refer_date': function () {
      this.get_lists_buy();
      // this.get_lists_final();
      this.get_lists_products();
    },

  },
  methods: {
    change_person(item) {
      var self = this

      this.refer_person_async = false
      this.refer_person_items = [
        {
          userId:item.personId,
          personCode:item.personName,
          userName:item.middelName,
          surName :item.surName,
        }  ]



      this.refer_person = item.personId
      setTimeout(function (){
        self.refer_person_async = true
      },300)
    },
    get_persons(){
      var self = this;
      const formData = new FormData();

      var url = "GetReferFactorPersons";


      if (this.refer_date != null) {
        formData.append("FDate", this.refer_date);
      }
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.persons = content_data.data
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });
    },
    get_all_data() {
      this.get_lists_buy();
      // this.get_lists_final();
      this.get_lists_products();
    },
    load_persons({action, searchQuery, callback}) {
      var self = this;
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          const formData = new FormData();

          formData.append('SearchTxt', searchQuery);
          var url = "GetAllPersons";

          formData.append('IsVendor', false);
          formData.append('IsWorker', true);
          formData.append('IsCustomer', false);
          formData.append('IsActive', 0);

          axios.post(url, formData, {show_pros: true}).then(function (response) {
            self.searched_persons = response.data.data
            options = response.data.data;

            callback(null, options);

          })
              .catch(function (error) {

                console.log(error);
              });

        })
      }
    },

    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },

    print_products() {
      // Pass the element id here
      this.$htmlToPaper('printMe_products');
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper('printMe');
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].unitName;
      this.color = this.items[item.row_id].color;
      this.description = this.items[item.row_id].description;
      this.previewImage = this.items[item.row_id].image;
      this.status_form = this.items[item.row_id].id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists_buy() {
      var self = this;


      const formData = new FormData();

      var url = "GetReferFactors";


      formData.append("id", this.refer_person);
      formData.append("Status", 0);

      if (this.refer_date != null) {
        formData.append("FDate", this.refer_date);
      }
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.id_checkbox_items = []

          self.items_buy = content_data.data.items.map((item, row_id) => {
            return {...item, row_id}

          });
          self.driver_name = response.data.data.UserName;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    add_signature(index) {


      let self = this;
      const formData = new FormData()
      let url;
      url = "AddFactorSigntrue";

      if (this.items_buy.length == 0) {
        return
      }
      if (this.id_checkbox_items.length == 0) {
        return
      }
      // formData.append('ids[]', this.items_buy[index].masterId);
      formData.append('MasterFactorId', this.id_checkbox_items[index]);
      formData.append('Summary', "");
      formData.append('file', new File([""], "empty.jpg"));



      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        if (res.data.statusCode == 0) {
          self.status_form = 0;
          if (index < self.id_checkbox_items.length - 1) {
            self.add_signature(index + 1)
          } else {
            self.get_lists_buy();

          }
        } else {
          // self.$root.modal_component.show_danger_modal("خطا", "فاکتور به درستی تسویه نگردید. شماره فاکتور:" + self.items_buy[index].masterCode);
          if (index < self.id_checkbox_items.length - 1) {
            self.add_signature(index + 1)
          } else {
            self.get_lists_buy();
          }

          // self.get_lists_buy();
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_lists_pdf() {
      var self = this;


      const formData = new FormData();
      if (this.refer_date == null) {
        var url = axios.defaults.baseURL + "/getpdf?id=" + this.refer_person + "&count=2";
        window.open(url, "_blank");

      } else {
        var url2 = axios.defaults.baseURL + "/getpdf?id=" + this.refer_person + "&count=2" + "&date=" + this.refer_date;

        window.open(url2, "_blank");

      }

    },
    get_lists_products() {
      var self = this;


      const formData = new FormData();

      var url = "GetPersonFactorInfo";

      formData.append("id", this.refer_person);
      if (this.refer_date != null) {
        formData.append("FDate", this.refer_date);
      }

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          if(self.get_access('document_sort_product')){
            content_data.data = content_data.data.sort((a, b) => a.productName.localeCompare(b.productName, undefined, {numeric: true, sensitivity: 'base'}));
          }
          self.items_products = content_data.data.map((item, row_id) => {
            return {...item, row_id}

          });


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },


    goEditPerson(item, index) {

      this.$router.push({path: '/dashboard/users/edit-user/' + this.items[index].userId});
      // this.$router.push({route_name: 'create_product' });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    goShowDocument(item, index) {
window.open('/dashboard/documents/show/' + item.masterFactorId)
      // this.$router.push({path: '/dashboard/documents/show/' + item.masterFactorId});
      // this.$router.push({route_name: 'create_product' });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    goPrintDocument(item, index) {
      bus.$emit("print_confirm", item.masterFactorId);

      // this.$router.push({route_name: 'create_product' });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    AddRefer(item, index) {
      this.submit_refer = item.recId;
      // this.$router.push({path: '/dashboard/documents/show/' + item.recId});
      // this.$router.push({route_name: 'create_product' });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },

    delete_item_dialog(item, index) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], 'delete_confirm_cancel_refer' + this.confirm_delete_name);

      this.status_form = item.masterFactorId;
    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "CancelFactorRefer";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists_buy();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },

  },

}

</script>
